import React from 'react'
import { Form, Stack } from 'react-bootstrap'

export interface ToggleCardProps {
  title: string
  description?: React.ReactNode
  warning?: React.ReactNode
  checked: boolean
  disabled?: boolean
  onChange: (checked: boolean) => void
}
export const ToggleCard: React.FC<ToggleCardProps> = ({ title, description, warning, checked, disabled = false, onChange }) => (
  <div className={'border rounded-4 p-3'}>
    <Stack direction='horizontal' className='justify-content-between gap-2'>
      <div className='d-flex flex-column'>
        <div className='fw-semibold'>{title}</div>
        {description ? <div className='text-muted small'>{description}</div> : null}
      </div>
      <Form.Switch checked={checked} disabled={disabled} onChange={(e) => onChange(e.target.checked)} />
    </Stack>
    {!checked && warning ? <div className='mt-2'>{warning}</div> : null}
  </div>
)
